module.exports = __webpack_public_path__ + "img/bottom-list7.e6db0aff.png";